// import * as config from 'config';

// ------------------------------------------------------------------------
// Polyfills
// ------------------------------------------------------------------------
require('./polyfills');


// ------------------------------------------------------------------------
// Other Libraries
// ------------------------------------------------------------------------


// ------------------------------------------------------------------------
// Vue
// ------------------------------------------------------------------------
require('./vue');


// ------------------------------------------------------------------------
// Enable Barba.js Page Transitions
// ------------------------------------------------------------------------
require('../barba2');
